var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',_vm._l(([].concat( _vm.iconsArr )),function(icon,index){return _c('img',{key:index,attrs:{"width":_vm.size,"height":_vm.size,"src":require(("@creativecommons/cc-assets/icons/cc-" + (_vm.filename(icon))))}})}),0)}
var staticRenderFns = []

export { render, staticRenderFns }